import { createContext } from 'preact-compat'
import { z } from 'zod'

export const userModel = z.object({
  id: z.number().or(z.null()),
  email: z.string(),
  name: z.string(),
  avatar: z.string(),
  isModerator: z.boolean(),
  rank: z.string().or(z.null()),
  rankIcon: z.string(),
  rankName: z.string(),
  role: z.string(),
  mainRole: z.string(),
  pmUnreadCount: z.number(),
  pmTotalCount: z.number(),
  topicsCount: z.number(),
  repliesCount: z.number(),
  solvedCount: z.number()
}).default({
  id: null,
  email: '',
  name: '',
  avatar: '',
  isModerator: false,
  rankIcon: '',
  rankName: '',
  rank: null,
  role: 'roles.guest',
  mainRole: 'roles.guest',
  pmUnreadCount: 0,
  pmTotalCount: 0,
  topicsCount: 0,
  repliesCount: 0,
  solvedCount: 0
})

export type UserModel = z.infer<typeof userModel>

export const userPermissionsModel = z.object({
  permissions: z.array(z.string()),
  readableCategories: z.array(z.number())
})

export type UserPermissions = z.infer<typeof userPermissionsModel>

export const CurrentUserContext = createContext<z.infer<typeof userModel>>(userModel.parse(undefined))
export const UserPermissionContext = createContext<UserPermissions>({ permissions: [], readableCategories: [] })
